import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { AnaliseDesconto } from '../models/analise-desconto';

@Injectable({
  providedIn: 'root'
})
export class AnaliseDescontoService {

  constructor(
    private http: HttpClient
  ) { }

  salvar(analiseDesconto: AnaliseDesconto) {
    return this.http.post<any>(globals.apiUrl + '/api/AnaliseDesconto/Salvar', analiseDesconto);
  }

  consultarAnalisesPorIdCupom(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDesconto/BuscarAnalisesPorIdCupom',
      { params: new HttpParams().set('idCupom', idCupom) });
  }

  consultarAnaliseAtualPorIdCupom(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDesconto/BuscarAnaliseAtualPorIdCupom',
      { params: new HttpParams().set('idCupom', idCupom) });
  }

  consultarAnalisePorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDesconto/BuscarAnalise',
      { params: new HttpParams().set('id', id) });
  }

  consultarAnalisePorIdTarefa(idTarefa) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDesconto/BuscarAnalisePorTarefa',
      { params: new HttpParams().set('idTarefa', idTarefa) });
  }

  consultarQuestionarioPreenchido(idAnalise, tipoAplicacao) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDesconto/BuscarQuestionarioPreenchido',
      { params: new HttpParams().set('idAnalise', idAnalise).set('tipoAplicacao', tipoAplicacao) });
  }

  alterarStatusAnalise(idAnalise, status, obs) {
    return this.http.post<any>(globals.apiUrl + '/api/AnaliseDesconto/AlterarStatusAnalise', { idAnalise, status, obs });
  }

  consultarLogPorIdAnalise(idAnalise) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDesconto/BuscarLog',
      { params: new HttpParams().set('idAnalise', idAnalise) });
  }

  consultarPossuiAnaliseEmAndamento(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDesconto/PossuiAnaliseEmAndamento',
      { params: new HttpParams().set('idCupom', idCupom) });
  }
}
